import axios from '../helpers/axios'
import { logError } from '../services';
import { IFramerDetail, IFramerDetailPut, IFramerRes, IDropdownResponse } from '../models';

const baseUrl = '/api/framers';

export const getFramers = async (filters?: {
  businessName?: string;
  contactName?: string;
  contactNumber?: string;
  activeBuildCountStart?: number;
  activeBuildCountEnd?: number;
  territory?: string;
  neighborhood?: string;
  sortBy?: string;
  sortDirection?: string;
  page?: number;
  perPage?: number | string;
}): Promise<IFramerRes> => {
  try {
    const { data } = await axios.get(baseUrl, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getFramers failed');
    return Promise.reject(error?.response?.data);
  }
};

export const postFramer = async (
  businessName: string,
  buildLimit: number,
  contactName: string,
  contactEmail: string,
  contactPhone: string
): Promise<any> => {
  try {
    const { data } = await axios.post(`${baseUrl}`, { businessName, buildLimit, contactName, contactEmail, contactPhone });
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload: {
          businessName,
          buildLimit,
          contactName,
          contactEmail,
          contactPhone
        }
      },
      'postFramer failed'
    );
    return Promise.reject(error?.response?.data);
  }
};

export const getFramerDetails = async (framerId: number): Promise<IFramerDetail | any> => {
  try {
    const { data } = await axios.get(`${baseUrl}/${framerId}`);
    return data;
  } catch (error) {
    logError(error, 'getFramerDetails failed');
    return error.response.data;
  }
};

export const updateFramer = async (
  framerId: number,
  businessName: string,
  buildLimit: number | string,
  contactName: string,
  contactEmail: string,
  contactPhone: string
): Promise<IFramerDetailPut> => {
  try {
    const { data } = await axios.put(`${baseUrl}/${framerId}`, { businessName, buildLimit, contactName, contactEmail, contactPhone });
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload: {
          businessName,
          buildLimit,
          contactName,
          contactEmail,
          contactPhone
        }
      },
      'updateFramer failed'
    );
    return Promise.reject(error?.response?.data);
  }
};

export const deleteFramer = async (framerId: number): Promise<any> => {
  try {
    const { data } = await axios.delete(`${baseUrl}/${framerId}`);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getFramerQueryData = async (): Promise<any> => {
  try {
    const { data } = await axios.get(`${baseUrl}`);
    return data;
  } catch (error) {
    logError(error, 'getFramerQueryData failed');
    return Promise.reject(error);
  }
};

export const getFramersLookup = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${baseUrl}/lookup`);
    return data;
  } catch (error) {
    logError(error, 'getFramersLookup failed');
    return Promise.reject(error?.response?.data);
  }
};

